import * as React from 'react';
// import React, { useState } from 'react';

import { ITableConfig } from '../../components/common/table';

import PagedResultSet from '../../models/common/PagedResultSet';
import PagedItemList from 'src/components/common/PagedItemList';
import CardContainer from '../common/CardContainer.redesign';
import * as Constants from 'src/components/common/Constants';

import Client from 'src/models/Client';

import { IRootState } from 'src/reducers';
import actions from 'src/actions';
import selectors from 'src/selectors';
import { connect } from 'react-redux';
import ClientCard from './ClientCard';
import Card from '../common/Card.redesign';
import Project from 'src/models/Project';
import ProjectCard from '../cards/ProjectCard';
import Panel from 'src/components/common/Panel';
import Page from 'src/components/common/Page';
import { ODataOptions, ODataOrderByDirection } from 'src/util/ODataBuilder';
import Filter from '../common/Filter';
import { push } from 'connected-react-router';
import { RouteComponentProps } from 'react-router-dom';

interface IClientsPageLocalProps {
    visibility: boolean;
    selectedClient: number;
    selectedProject: number;
}

interface IClientsPageStateProps {
    isLoading: boolean;
    client: Client;
    clients: PagedResultSet<Client>;
    projects: PagedResultSet<Project>;
    tableConfig: ITableConfig;
}
interface IClientsPageDispatchProps {
    initializePage: () => void;
    getClient: (clientNumber: number) => void;
    getClients: (options: ODataOptions, resetSearch: boolean) => void;
    initializeProjects: () => void;
    getProjects: (clientNumber: number, options: ODataOptions, resetSearch: boolean) => void;
    refreshIntegratedProjects: (clientNumber: number) => void;
    navigate: (path: string) => void;
    showDialog: (dialogName: string) => void;
    incrementPage: () => void;
    decrementPage: () => void;
}

type IClientPageProps = IClientsPageStateProps & IClientsPageDispatchProps & RouteComponentProps<{ clientNumber?: string }>;

class ClientsPage extends React.Component<IClientPageProps, IClientsPageLocalProps> {
    constructor(props: IClientPageProps) {
        super(props);
        this.state = {
            visibility: false,
            selectedClient: undefined,
            selectedProject: undefined,
        };

        this.isClientSelected = false;
        this.projectFilterChanged = false;
        this.clientIdChanged = false;
        const tableConfig: ITableConfig = {
            rowCount: 20,
            idField: 'id',
            pageNumber: 1,
            columns: []
        };
        this.projectDataOptions = ODataOptions.from(tableConfig);
        this.projectDataOptions.addOrderBy('ProjectNumber', ODataOrderByDirection.Descending);
        this.totalProjectRecords = 0;
    }

    private isClientSelected: boolean;
    private projectFilterChanged: boolean;
    private clientIdChanged: boolean;
    private totalProjectRecords: number;
    private projectDataOptions: ODataOptions;

    private resetPagingOptions() {
        const tableConfig: ITableConfig = {
            rowCount: 20,
            idField: 'id',
            pageNumber: 1,
            columns: []
        };
        let newDataOptions = ODataOptions.from(tableConfig);
        this.projectDataOptions = newDataOptions.merge(this.projectDataOptions);
        this.projectDataOptions.addOrderBy('ProjectNumber', ODataOrderByDirection.Descending);
    }

    public componentDidMount() {
        this.props.initializePage();
        this.props.getClients(new ODataOptions(), true);
        this.props.initializeProjects();

        const clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        if (clientNumber) {
            this.setState({ selectedClient: clientNumber });
            this.props.getClient(clientNumber);
            this.props.getProjects(clientNumber, this.projectDataOptions, true);
        } else {
            this.props.navigate('/clients/');
        }
    }

    projectStateChangedCallback = () => {
        this.getProjects(this.projectDataOptions, true);
    }

    clientClick = (clientNumber: number) => {
        this.isClientSelected = true;        
        if (this.state.selectedClient !== clientNumber) {
            this.props.initializeProjects();
            this.clientIdChanged = true;
            this.setState({ selectedClient: clientNumber }, this.projectStateChangedCallback);            
            this.resetPagingOptions();
        }
        this.props.getClient(clientNumber);
    };

    getProjects = (dataOptions: ODataOptions, resetSearch: boolean) => {
        this.props.getProjects(this.state.selectedClient, dataOptions, resetSearch);
        this.clientIdChanged = false;
    };

    resetPagingOptionsCallback = () => {
        this.clientIdChanged = false;
        this.projectFilterChanged = false;
        this.resetPagingOptions();
        this.getProjects(this.projectDataOptions, false);
    }

    projectClick = () => {
        console.log('click project');
    };

    addClientClick = () => {
        this.props.navigate('/clients/create');
    };

    addProjectClick = () => {
        if (!this.state.selectedClient) {
            alert('Select Client First');
        } else {
            this.props.navigate(`/clients/${this.state.selectedClient}/add-project`);
        }
    };

    refreshIntegratedProjects = () => {
        const clientNumber = parseInt(this.props.match.params.clientNumber, 10);

        if (this.state?.selectedClient) {
            this.props.refreshIntegratedProjects(this.state.selectedClient);
        } else if (this.props?.match?.params && clientNumber) {
            this.setState({selectedClient: clientNumber});
            this.props.refreshIntegratedProjects(clientNumber);
            console.log('===========>', this.props.match);
        } else {
            this.props.navigate('/clients/');
        }
    };

    editClient = (clientNumber: number) => {
        this.props.navigate(`/clients/${clientNumber}/edit`);
    };

    showShadow = (client: Client) => {
        this.setState({ visibility: true });
        client.isRealVisible = true;
        setTimeout(() => {
            this.hideShadow(client);
            this.setState({ visibility: false });
        }, 2000);
    };

    hideShadow = (client: Client) => {
        this.setState({ visibility: false });
        client.isRealVisible = false;
    };

    toggleShadow = (client: Client) => {
        if (client.isRealVisible) {
            this.hideShadow(client);
        } else {
            this.showShadow(client);
        }
    };

    projectFilterActions = () => {
        if (!this.props.client) {
            return [];
        }

        if (this.props.client.calmsSourced) {
            return [{ text: 'Refresh CALMS Projects', action: this.refreshIntegratedProjects }];
        } else {
            return [{ text: 'Add Project', action: this.addProjectClick }];
        }
    };

    displayExistingClients = () => {
        if (this.props.clients?.items?.length > 0) {
            return this.props.clients.items.map((c: Client) => {
                return (
                    <ClientCard
                        key={`client-${c.id}`}
                        client={c}
                        onClick={() => this.clientClick(c.clientNumber)}
                        editClient={() => this.editClient(c.clientNumber)}
                        selectedClientId={this.state.selectedClient}
                    />
                );
            });
        } else {
            return <div>No Clients</div>;
        }
    };

    displayProjects = () => {
        if (this.props.projects && this.props.projects.items) {
            return this.props.projects.items.map((p: Project) => {
                const navToProjectAction = () => {
                    this.props.navigate(`/clients/${p.client.clientNumber}/projects/${p.projectNumber}/tracts`);
                };
                const navToEditAction = () => { 
                    this.props.navigate(`/clients/${p.client.clientNumber}/projects/${p.projectNumber}/settings`);
                };
                const navToAdministerAction = () => {
                    this.props.navigate(`/clients/${p.client.clientNumber}/projects/${p.projectNumber}/settings`);
                };

                return (
                    <ProjectCard
                        key={`project-${p.id}`}
                        project={p}
                        onEditProjectClick={p.updateNeeded ? navToEditAction : navToProjectAction}
                        onAdministerProjectClick={navToAdministerAction}
                    />
                );
            });
        } else {
            return <div>No Projects</div>;
        }
    };

    projectCards = () => {
        const cards = [];

        for (let i = 1; i <= 5; i++) {
            cards.push(
                <Card key={i} badge={`Project ${i}`}>
                    <div style={{ padding: '1rem' }}>
                        <div>Project {i}</div>
                        <div>Other data about the project</div>
                    </div>
                </Card>
            );
        }

        return cards;
    };

    handleClientFilterChanged = (options: ODataOptions) => {
        console.log('at component', options);
        this.props.initializePage();
        this.props.initializeProjects();
        this.setState({ selectedClient: undefined }, () =>
            this.props.getClients(options, true)
        );
    };

    handleProjectFilterChanged = (options: ODataOptions) => {
        if (this.state.selectedClient) {
            this.projectFilterChanged = true;
            this.props.initializePage();
            this.props.initializeProjects();
            this.projectDataOptions.clearFilters();
            this.projectDataOptions.merge(options);
            this.projectDataOptions.addPaging(Constants.clientPageProjectQueryStartingPage, Constants.clientPageProjectListDefaultRowCount);
            let orderByProperty = options.getOrderByProperty() !== undefined ? options.getOrderByProperty() : Constants.clientPageProjectQueryOrderByIdColumn;
            let orderByDirection = options.getOrderByDirection() !== undefined ? options.getOrderByDirection() : ODataOrderByDirection.Descending;
            this.projectDataOptions.addOrderBy(orderByProperty, orderByDirection);
            this.projectDataOptions.addPaging(Constants.clientPageProjectQueryStartingPage, Constants.clientPageProjectListDefaultRowCount);
            this.props.getProjects(this.state.selectedClient, this.projectDataOptions, true);
        }
    };

    public render() {
        const { clients } = this.props;
        let isOnLastPage = false;
        this.totalProjectRecords = this.props.projects ? this.props.projects.totalRecords : 0;

        if (clients) {
            isOnLastPage = clients.pageNumber * clients.pageSize < clients.totalRecords;
        }

        return (
            <Page>
                <Page.Section width={6}>
                    <Panel fitPanelToScreen={true} customSize={2}>
                        <div>
                            <div className="dlc-content-panel-header">Clients</div>
                            {/* <button onClick={this.addClientClick}>Add Client</button> */}
                            <Filter
                                sortItems={[
                                    { group: 1, text: 'Name', icon: 'alpha-up', orderName: 'name', orderDirection: 'ascending' },
                                    { group: 1, text: 'Name Desc', icon: 'alpha-down', orderName: 'name', orderDirection: 'descending' },
                                    { group: 1, text: 'Number', icon: 'numeric-up', orderName: 'clientNumber', orderDirection: 'ascending' },
                                    { group: 1, text: 'Number Desc', icon: 'numeric-down', orderName: 'clientNumber', orderDirection: 'descending' },
                                ]}
                                actions={[{ text: 'Create Client', action: this.addClientClick }]}
                                onFilterChanged={this.handleClientFilterChanged}
                                // omniSearchFields={['name', 'clientNumber']}
                            />
                        </div>
                        <CardContainer
                            className="clients-page-client-list"
                            showNextPagePanel={isOnLastPage}
                            nextPageAction={this.props.incrementPage}
                            style={{ overflowY: 'scroll' }}
                        >
                            {this.displayExistingClients()}
                            <div style={{ height: '3rem' }}/>
                        </CardContainer>
                    </Panel>
                </Page.Section>
                <Page.Section width={6}>
                    <Panel fitPanelToScreen={true} customSize={2}>
                        <div className="dlc-content-panel-header">Projects</div>
                        {/*<button onClick={this.addProjectClick}>Add Project</button>*/}
                        <Filter
                            sortItems={[
                                { group: 1, text: 'Name', icon: 'alpha-up', orderName: 'name', orderDirection: 'ascending' },
                                { group: 1, text: 'Name Desc', icon: 'alpha-down', orderName: 'name', orderDirection: 'descending' },
                                { group: 1, text: 'Number', icon: 'numeric-up', orderName: 'projectNumber', orderDirection: 'ascending' },
                                { group: 1, text: 'Number Desc', icon: 'numeric-down', orderName: 'projectNumber', orderDirection: 'descending' },
                            ]}
                            actions={this.projectFilterActions()}
                            onFilterChanged={this.handleProjectFilterChanged}
                            // omniSearchFields={['name', 'projectNumber']}
                        />
                        <PagedItemList 
                            className="clients-page-project-list"
                            style={{ overflowY: 'scroll' }}
                            resetLastPage={this.clientIdChanged || this.projectFilterChanged}
                            ResetStateCallback={this.resetPagingOptionsCallback}
                            optionalCondition={this.isClientSelected}
                            dataOptions={this.projectDataOptions}
                            GetPagedItemList={this.getProjects}
                            DisplayList={this.displayProjects}
                            orderByColumn={this.projectDataOptions.getOrderByProperty() !== undefined ?
                                 this.projectDataOptions.getOrderByProperty() : Constants.clientPageProjectQueryOrderByIdColumn}
                            orderByDirection={this.projectDataOptions.getOrderByDirection() !== undefined ?
                                 this.projectDataOptions.getOrderByDirection() : ODataOrderByDirection.Descending}
                            startingPage={Constants.clientPageProjectQueryStartingPage}
                            rowsPerPage={Constants.clientPageProjectListDefaultRowCount}
                            totalRows={this.totalProjectRecords}
                        >
                            <div style={{ height: '3rem' }}/> 
                        </PagedItemList>
                    </Panel>
                </Page.Section>
            </Page>
        );
    }
}

function mapStateToProps(state: IRootState): IClientsPageStateProps {
    return {
        isLoading: selectors.client.isLoadingClients(state),
        client: selectors.client.client(state),
        clients: selectors.client.clients(state),
        projects: selectors.project.projects(state),
        tableConfig: selectors.client.clientsPageTableConfig(state),
    };
}

const mapDispatchToProps: IClientsPageDispatchProps = {
    getClient: (clientNumber: number) => actions.client.getClient(clientNumber),
    getClients: (options: ODataOptions, resetSearch: boolean) => actions.client.getClients(options, resetSearch),
    initializeProjects: () => actions.project.initializeProjects(),
    getProjects: (clientNumber: number, options: ODataOptions, resetSearch: boolean) =>
        actions.project.getProjects(clientNumber, options, resetSearch),
    refreshIntegratedProjects: (clientNumber: number) => actions.project.refreshIntegratedProjects(clientNumber),
    navigate: (path: string) => push(path),
    initializePage: () => actions.client.initializeClientPage(),
    incrementPage: () => actions.client.incrementClientPage(),
    decrementPage: () => actions.client.decrementClientPage(),
    showDialog: (dialogName: string) => actions.layout.showDialog(dialogName),
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientsPage);



// WEBPACK FOOTER //
// ./src/components/clients/ClientsPage.tsx